export interface CollectionCapacitySummary {
  status: 'loading' | 'ready' | 'error' | 'inactive';
  countedItems?: number;
  effectiveLimit?: number;
}

export function collectionCapacityLabel(capacity?: CollectionCapacitySummary) {
  return capacity?.status === 'ready' && capacity.countedItems !== undefined
    ? `${capacity.countedItems.toLocaleString()} items`
    : undefined;
}

export function accessibleCollectionName(name: string) {
  return Array.from(name, (character) => {
    const codePoint = character.codePointAt(0) || 0;
    return codePoint <= 0x1f ||
      (codePoint >= 0x7f && codePoint <= 0x9f) ||
      codePoint === 0x61c ||
      codePoint === 0x200e ||
      codePoint === 0x200f ||
      (codePoint >= 0x2028 && codePoint <= 0x202e) ||
      (codePoint >= 0x2066 && codePoint <= 0x2069)
      ? ' '
      : character;
  })
    .join('')
    .replace(/\s+/gu, ' ')
    .trim();
}
